import { useLocation } from 'react-router-dom';
import routes from '@src/constants/route';

const useCheckDubbingRoute = () => {
  const location = useLocation();

  const arrayPath = location.pathname.split('/');
  return (
    arrayPath[1] === 'dubbing' ||
    (arrayPath[1] === 'studio' && arrayPath[2] === 'dubbing')
  );
};

const useCheckSTTRoute = () => {
  const location = useLocation();

  const arrayPath = location.pathname.split('/');
  return arrayPath[2] === 'speech-to-text';
};

const useCheckCloningRoute = () => {
  const location = useLocation();
  const arrayPath = location.pathname.split('/');
  return arrayPath[2] === 'voice-cloning';
};

const useCheckTTSRoute = () => {
  const location = useLocation();
  const arrayPath = location.pathname.split('/');
  return arrayPath[1] === 'studio';
};

const useCheckAPIRoute = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const packageType = queryParams.get('packageType');

  return packageType === 'API';
};

const useCheckProjectRoute = () => {
  const location = useLocation();
  const arrayPath = location.pathname.split('/');
  return arrayPath[1] === 'projects' && arrayPath[2];
};

const useCheckHomeProjectRoute = () => {
  const location = useLocation();
  const arrayPath = location.pathname.split('/');
  return arrayPath[1] === 'projects';
};

const useCheckEducatorsRoute = () => {
  const location = useLocation();
  const arrayPath = location.pathname.split('/');
  return arrayPath[1] === 'educators';
};

// The home page rather than the Educators section, which is what the popups it
// opens have to wait on. The two are the same page today and would drift apart
// the moment a second Educators route appears.
const useCheckEducatorsHomeRoute = () => {
  const location = useLocation();
  return location.pathname === routes.EDUCATORS_HOME;
};

export {
  useCheckDubbingRoute,
  useCheckSTTRoute,
  useCheckCloningRoute,
  useCheckTTSRoute,
  useCheckAPIRoute,
  useCheckProjectRoute,
  useCheckHomeProjectRoute,
  useCheckEducatorsRoute,
  useCheckEducatorsHomeRoute,
};
